<template>
  <v-container :class="isMobile? 'pt-0':'pb-0 pl-0'">
      <v-card>
          <v-card-title><h3 :style="'color:' + theme.primary.base"><v-icon :style="'color:inherit;'">attach_money</v-icon>Your price details</h3></v-card-title>
          <v-card-text>
            <table style="width:100%;margin-bottom:5px;">
              <tr><td colspan="2" style="font-weight:bold;">Prices</td></tr>
              <tr v-if="showAmount(priceInfo.prices.adult)"><td>&nbsp;Adult</td> <td style="text-align:right;">{{priceInfo.adultCount + ' x ' + helper.numberFormat.formatPrice(convertedPrices.adult)}}</td></tr>
              <tr v-if="showAmount(priceInfo.prices.child)"><td>&nbsp;Child</td> <td style="text-align:right;">{{priceInfo.childrenCount + ' x ' + helper.numberFormat.formatPrice(convertedPrices.child)}}</td></tr>
              <tr v-if="showAmount(priceInfo.prices.infant)"><td>&nbsp;Infant</td> <td style="text-align:right;">{{priceInfo.infantCount + ' x ' + helper.numberFormat.formatPrice(convertedPrices.infant)}}</td></tr>
              <tr v-if="showAmount(priceInfo.prices.student)"><td>&nbsp;Student</td> <td style="text-align:right;">{{priceInfo.studentCount + ' x ' + helper.numberFormat.formatPrice(convertedPrices.student)}}</td></tr>
            </table>
            <table style="width:100%;margin-bottom:5px;">
              <tr><td colspan="2" style="font-weight:bold;">Taxes</td></tr>
              <tr v-if="showAmount(priceInfo.taxes.adult)"><td>&nbsp;Adult</td> <td style="text-align:right;">{{priceInfo.adultCount + ' x ' + helper.numberFormat.formatPrice(convertedTaxes.adult)}}</td></tr>
              <tr v-if="showAmount(priceInfo.taxes.child)"><td>&nbsp;Child</td> <td style="text-align:right;">{{priceInfo.childrenCount + ' x ' + helper.numberFormat.formatPrice(convertedTaxes.child)}}</td></tr>
              <tr v-if="showAmount(priceInfo.taxes.infant)"><td>&nbsp;Infant</td> <td style="text-align:right;">{{priceInfo.infantCount + ' x ' + helper.numberFormat.formatPrice(convertedTaxes.infant)}}</td></tr>
              <tr v-if="showAmount(priceInfo.taxes.student)"><td>&nbsp;Student</td> <td style="text-align:right;">{{priceInfo.studentCount + ' x ' + helper.numberFormat.formatPrice(convertedTaxes.student)}}</td></tr>
            </table>
            <table v-if="showQSurcharge" style="width:100%;margin-bottom:5px;">
              <tr><td colspan="2" style="font-weight:bold;">Q Surcharge</td></tr>
              <tr v-if="showAmount(priceInfo.qSurcharge.adult)"><td>&nbsp;Adult</td> <td style="text-align:right;">{{priceInfo.adultCount + ' x ' + helper.numberFormat.formatPrice(convertedQSurcharges.adult)}}</td></tr>
              <tr v-if="showAmount(priceInfo.qSurcharge.child)"><td>&nbsp;Child</td> <td style="text-align:right;">{{priceInfo.childrenCount + ' x ' + helper.numberFormat.formatPrice(convertedQSurcharges.child)}}</td></tr>
              <tr v-if="showAmount(priceInfo.qSurcharge.infant)"><td>&nbsp;Infant</td> <td style="text-align:right;">{{priceInfo.infantCount + ' x ' + helper.numberFormat.formatPrice(convertedQSurchargese.infant)}}</td></tr>
              <tr v-if="showAmount(priceInfo.qSurcharge.student)"><td>&nbsp;Student</td> <td style="text-align:right;">{{priceInfo.studentCount + ' x ' + helper.numberFormat.formatPrice(convertedQSurchargese.student)}}</td></tr>
            </table>       
            <table v-if="getProcessingFee>0" style="width:100%;margin-bottom:5px;">
              <tr><td colspan="2" style="font-weight:bold;">Other Charges</td></tr>
              <tr><td>&nbsp;Processing Fee</td><td style="text-align:right;">{{helper.numberFormat.formatPrice(getProcessingFee)}}</td></tr>
            </table>    
            <table style="width:100%;">
              <tr style="font-weight:bold;"><td>Total fare</td> <td style="text-align:right;">{{helper.numberFormat.formatPrice(getTotalFare())}}</td></tr>
            </table>                           
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import Theme from '../../theme';
import Helper from '../helper';
import { isNumber } from 'util';

export default {
  props:[
    'priceInfo','processingFee', 'sellingCurrency'
  ],
  data(){
    return {
      theme:Theme,
      helper:Helper,
    }
  },
  created(){
    setTimeout(() => {
      // alert(JSON.stringify( this.sellingCurrency))
    }, 2000);
  },
  methods:{
    showInSellingCurrency(amount) {
      try {
        const amnt = Math.ceil(this.sellingCurrency.fxRate * amount)
        return amnt
      } catch (error) {
        console.error(error)
        return 0
      }
    },
    getTotalFare(){

      let fnc = (v)=>{
        if (v!=null&&isNumber(v)){
          return +v;
        }else{
          return 0;
        }
      }

      let adtPrc = fnc(this.priceInfo.prices.adult);
      let cnnPrc = fnc(this.priceInfo.prices.child);
      let infPrc = fnc(this.priceInfo.prices.infant);
      let stuPrc = fnc(this.priceInfo.prices.student);

      let adtTx = fnc(this.priceInfo.taxes.adult);
      let cnnTx = fnc(this.priceInfo.taxes.child);
      let infTx = fnc(this.priceInfo.taxes.infant);
      let stuTx = fnc(this.priceInfo.taxes.student);

      let adtQ = fnc(this.priceInfo.qSurcharge.adult);
      let cnnQ = fnc(this.priceInfo.qSurcharge.child);
      let infQ = fnc(this.priceInfo.qSurcharge.infant);      
      let stuQ = fnc(this.priceInfo.qSurcharge.student);      

      let adtPrice = adtPrc * fnc(this.priceInfo.adultCount);
      let cnnPrice = cnnPrc * fnc(this.priceInfo.childrenCount);
      let infPrice = infPrc * fnc(this.priceInfo.infantCount);
      let stuPrice = stuPrc * fnc(this.priceInfo.studentCount);
      
      let adtTax = adtTx * fnc(this.priceInfo.adultCount);
      let cnnTax = cnnTx * fnc(this.priceInfo.childrenCount);
      let infTax = infTx * fnc(this.priceInfo.infantCount);
      let stuTax = stuTx * fnc(this.priceInfo.studentCount);

      let adtQSurcharge = adtQ * fnc(this.priceInfo.adultCount);
      let cnnQSurcharge = cnnQ * fnc(this.priceInfo.childrenCount);
      let infQSurcharge = infQ * fnc(this.priceInfo.infantCount);
      let stuQSurcharge = stuQ * fnc(this.priceInfo.studentCount);

      let totalFare = adtPrice+cnnPrice+infPrice+stuPrice;
      totalFare = totalFare + adtTax + cnnTax + infTax + stuTax;
      totalFare = totalFare + adtQSurcharge + cnnQSurcharge + infQSurcharge + stuQSurcharge + this.getProcessingFee;

      if (this.sellingCurrency.code != ''){
        totalFare = Math.ceil(totalFare * this.sellingCurrency.fxRate)
      }
      return totalFare;
    },
    showAmount(amount){
      let amnt = !isNaN(amount)? amount:0;
      return amnt;
    }    
  },
  computed:{
    convertedPrices() {
      let prices = {
        adult: this.priceInfo.prices.adult,
        child: this.priceInfo.prices.child,
        infant: this.priceInfo.prices.infant,
        student: this.priceInfo.prices.student
      }
      if (this.sellingCurrency.code != ''){
        prices = {
          adult: Math.ceil(this.priceInfo.prices.adult * this.sellingCurrency.fxRate),
          child: Math.ceil(this.priceInfo.prices.child * this.sellingCurrency.fxRate),
          infant: Math.ceil(this.priceInfo.prices.infant * this.sellingCurrency.fxRate),
          student: Math.ceil(this.priceInfo.prices.student * this.sellingCurrency.fxRate)
        }
      }
      return prices
    },
    convertedTaxes() {
      let taxes = {
        adult: this.priceInfo.taxes.adult,
        child: this.priceInfo.taxes.child,
        infant: this.priceInfo.taxes.infant,
        student: this.priceInfo.taxes.student
      }
      if (this.sellingCurrency.code != ''){
        taxes = {
          adult: Math.ceil(this.priceInfo.taxes.adult * this.sellingCurrency.fxRate),
          child: Math.ceil(this.priceInfo.taxes.child * this.sellingCurrency.fxRate),
          infant: Math.ceil(this.priceInfo.taxes.infant * this.sellingCurrency.fxRate),
          student: Math.ceil(this.priceInfo.taxes.student * this.sellingCurrency.fxRate)
        }
      }
      return taxes
    },

    convertedQSurcharges() {
      let qSurcharges = {
        adult: this.priceInfo.qSurcharge.adult,
        child: this.priceInfo.qSurcharge.child,
        infant: this.priceInfo.qSurcharge.infant,
        student: this.priceInfo.qSurcharge.infant
      }
      if (this.sellingCurrency.code != ''){
        qSurcharges = {
          adult: Math.ceil(this.priceInfo.qSurcharge.adult * this.sellingCurrency.fxRate),
          child: Math.ceil(this.priceInfo.qSurcharge.child * this.sellingCurrency.fxRate),
          infant: Math.ceil(this.priceInfo.qSurcharge.infant * this.sellingCurrency.fxRate),
          student: Math.ceil(this.priceInfo.qSurcharge.infant * this.sellingCurrency.fxRate)
        }
      }
      return qSurcharges
    },
    getProcessingFee(){
      let val= this.processingFee;
      if (val==null) val = 0;
      return val;
    },
    isMobile(){
        return Helper.display.isMobile(this.$vuetify.breakpoint.name);
    },  
    showQSurcharge(){
      let qschg = this.priceInfo.qSurcharge;
      let adultVal = !isNaN(qschg.adult) ? qschg.adult:0;
      let childVal = !isNaN(qschg.child) ? qschg.child:0;
      let infantVal = !isNaN(qschg.infant) ? qschg.infant:0;
      let studentVal = !isNaN(qschg.student) ? qschg.student:0;
      return (adultVal + childVal + infantVal + studentVal) > 0;
    },
  },
}
</script>

<style>

</style>